module.exports = __webpack_public_path__ + "static/media/kid-parent-with-child-toddler-svgrepo-com.57fa77d2.svg";